import { render, staticRenderFns } from "./ordersListDetailTable.vue?vue&type=template&id=7c7b60d6&scoped=true"
import script from "./ordersListDetailTable.vue?vue&type=script&lang=js"
export * from "./ordersListDetailTable.vue?vue&type=script&lang=js"
import style0 from "./ordersListDetailTable.vue?vue&type=style&index=0&id=7c7b60d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7b60d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c7b60d6')) {
      api.createRecord('7c7b60d6', component.options)
    } else {
      api.reload('7c7b60d6', component.options)
    }
    module.hot.accept("./ordersListDetailTable.vue?vue&type=template&id=7c7b60d6&scoped=true", function () {
      api.rerender('7c7b60d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformOrderManagement/components/ordersListDetailTable.vue"
export default component.exports